import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';

var _createNamespace = createNamespace('row'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

export default {
    name: getComponentName('Row'),
    data: function data() {
        return {};
    },
    props: {
        align: {
            type: String,
            default: function _default() {
                return 'start';
            }
        },
        justify: {
            type: String,
            default: function _default() {
                return 'top';
            }
        },
        stretch: {
            type: Boolean,
            default: false
        }
    },
    render: function render() {
        var h = arguments[0];
        return h(
            'div',
            {
                class: [
                    b(['align-'.concat(this.align), 'justify-'.concat(this.justify)]),
                    {
                        'mai-flex-1': this.stretch
                    }
                ],
                on: {
                    click: this.handleClick
                }
            },
            [this.$slots.default]
        );
    },
    methods: {
        handleClick: function handleClick(e) {
            this.$emit('click', e);
        }
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
